import React, { useEffect, useRef, useState } from "react";
import { useGetFiltersOptionsMutation } from "../../dataApiSlice";
import {
  getL1SheetProperty,
  setCommonFilters,
  updateLevel2Properties,
} from "../../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import FilterDropDown from "./FilterDropDown";
import SingleValueList from "./SingleValueList";
import MultipleValueList from "./MultipleValueList";
import MultiValueDropDown from "./MultiValueDropDown";
import MultiplevalueCustomList from "./MultiplevalueCustomList";
import isEqual from "lodash.isequal";
import Aside3RelativeDate from "./Aside3RelativeDate";
import LoadingIndicator from "../../../../components/BasicComponents/LoadingIndicator";
import Number from "./Number";
import Aside3DateRangeComp from "./Aside3DateRangeComp";

export default function Aside3Filter({
  item,
  index,
  Sheetid,
  dashboardSheetID,
  filterArray,
  isFilterVisibleInDashboard,
  commonFilters,
  reduxFilterType,
  currentSheetType,
  dashboardType,
}) {
  const {
    columnName: droppedFilterItem,
    format,
    isRelevant,
    filterField,
    columnType,
    formula,
    dataType,
    isRelativeDate,
    isApplyVisible,
    selectedOperator,
    nanoId,
    selectedMeasure,
  } = item;
  console.log(item);

  const [selectedFilterValues, setSelectedFilterValues] = useState(
    item.selectedFilterValues
  );
  const dispatch = useDispatch();
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );

  const [filterComponentType, setFilterType] = useState(
    item.filterComponentType
      ? item.filterComponentType
      : reduxFilterType
      ? reduxFilterType
      : "MultiValueDropdown"
  );
  const [showApplyBtn, setShowApplyBtn] = useState(false);

  const dispatchUpdateItem = (selectedFilterValues, isAll) => {
    console.log("dispatching item");
    const updatedValueObject = { ...item, selectedFilterValues, isAll };
    dispatch(
      setCommonFilters({
        Sheetid,
        operation: "UPDATE",
        value: updatedValueObject,
      })
    );
  };

  const updateNumberFilterItem = (dataType, updatedNumberFilterItem) => {
    if (dataType === "Number") {
      console.log(updatedNumberFilterItem);
      dispatch(
        setCommonFilters({
          Sheetid,
          operation: "UPDATE",
          value: updatedNumberFilterItem,
        })
      );
    }
  };
  const updateDateFilterItem = (dataType, updatedNumberFilterItem) => {
    if (dataType === "Date") {
      console.log(updatedNumberFilterItem);
      dispatch(
        setCommonFilters({
          Sheetid,
          operation: "UPDATE",
          value: updatedNumberFilterItem,
        })
      );
    }
  };

  useEffect(() => {
    setSelectedFilterValues(item.selectedFilterValues);
  }, [item.selectedFilterValues]);

  const [getFiltersOptions, { data, isError, error, isLoading, isSuccess }] =
    useGetFiltersOptionsMutation();

  useEffect(() => {
    // default case for filter body if conditions doesn't match filterBody will get used
    // default case for filter body if conditions doesn't match filterBody will get used
    let filterBody = null;
    if (dataType === "Date") {
      if (isRelativeDate) {
        filterBody = null;
      } else if (selectedOperator === "IN") {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: droppedFilterItem, format: format, dataType }],
        };
      } else {
        filterBody = null;
      }
    } else if (columnType === "calculatedField" && formula !== null) {
      filterBody = {
        databaseID: dataSourceID,
        columns: [
          {
            name: droppedFilterItem,
            formula: formula,
            fieldType: "calculatedField",
            dataType,
          },
        ],
      };
    } else if (isRelevant) {
      console.log("filter isRelevant is true");
    } else if (dataType === "String") {
      filterBody = {
        databaseID: dataSourceID,
        columns: [{ name: droppedFilterItem, dataType }],
      };
    }
    console.log(filterBody);
    if (filterBody !== null) {
      console.log(filterBody);
      getFiltersOptions({ filterBody, calledFrom: "aside3Filter" });
    }
  }, []);
  const prevFilterArrayRef = useRef([]);
  useEffect(() => {
    if (isRelevant) {
      let requiredFilterArrayAccordingToDataType = [];
  
      if (dataType === "Date") {
        requiredFilterArrayAccordingToDataType = filterArray.filter(
          (filteredItem) => filteredItem.nanoId !== nanoId
        );
      }
      if (dataType === "String") {
        requiredFilterArrayAccordingToDataType = filterArray.filter(
          (filteredItem) => filteredItem.columnName !== droppedFilterItem
        );
      }
  
      let filterConditions = requiredFilterArrayAccordingToDataType
        .filter((filterItem) => !filterItem.isAll) // Exclude items where isAll is true
        .map((filterItem) => ({
          column: filterItem.columnName,
          operator: filterItem.selectedOperator,
          value: filterItem.selectedFilterValues,
          format: filterItem.format,
          dataType: filterItem.dataType,
        }));
  
      let filterBody = null;
  
      if (dataType === "String") {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: droppedFilterItem, dataType }],
          conditions: filterConditions,
        };
      }
  
      if (dataType === "Date") {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: droppedFilterItem, format: format, dataType }],
          conditions: filterConditions,
        };
      }
  
      // Check if filterArray has actually changed
      if (
        filterBody !== null &&
        JSON.stringify(prevFilterArrayRef.current) !== JSON.stringify(filterArray)
      ) {
        console.log(filterBody);
        getFiltersOptions({ filterBody, calledFrom: "aside3Filter" });
  
        // Update previous filter array reference
        prevFilterArrayRef.current = filterArray;
      }
    } else {
      console.log("filter isRelevant is false");
    }
  }, [filterArray, isRelevant]);

  useEffect(() => {
    if (data) {
      console.log("Processing data:", data);

      const itemFoundInQueryFilters =
        filterArray[index] &&
        filterArray[index].isRelevant &&
        filterArray[index].columnName === Object.keys(data)[0];
      const itemFoundInCommonFilters =
        commonFilters[index] &&
        commonFilters[index].isRelevant &&
        commonFilters[index].columnName === Object.keys(data)[0];

      if (itemFoundInQueryFilters) {
        const updatedFilterArray = [...filterArray];
        updatedFilterArray[index] = {
          ...item,
          selectedFilterValues: data[item.columnName],
        };
        console.log("item found in query filters");
        if (!isEqual(updatedFilterArray, filterArray)) {
          dispatch(
            updateLevel2Properties({
              reduxKey: "filters",
              Sheetid,
              parentKey: "query",
              value: updatedFilterArray,
              itemInArray: false,
              index: index,
            })
          );
        }
      }

      if (itemFoundInCommonFilters) {
        const updatedCommonFilters = [...commonFilters];
        updatedCommonFilters[index] = {
          ...item,
          selectedFilterValues: data[item.columnName],
        };
        console.log("item found in common filters");
        if (!isEqual(updatedCommonFilters, commonFilters)) {
          updatedCommonFilters.forEach((updatedItem) => {
            dispatch(
              setCommonFilters({
                Sheetid,
                operation: "UPDATE",
                value: updatedItem,
              })
            );
          });
        }
      }
    }
  }, [data]);

  if (isError) {
    console.log(error);

    return (
      <div className="font-medium text-red-500">
        Error: {error["data"]["message"]}
      </div>
    );
  }

  if (isLoading) {
    return <LoadingIndicator />;
  }

  const renderFilterComponent = (
    filterComponentType,
    key,
    value,
    data,
    filterItem
  ) => {
    console.log(filterItem.dataType);

    switch (filterComponentType) {
      case "SingleValueList":
        return (
          <SingleValueList
            columnName={key}
            allOptions={value}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilters={setSelectedFilterValues}
            dispatchUpdateItem={dispatchUpdateItem}
          />
        );
      case "MultiValueDropdown":
        return (
          <MultiValueDropDown
            columnName={key}
            allOptions={value}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilters={setSelectedFilterValues}
            dispatchUpdateItem={dispatchUpdateItem}
            showApplyBtn={showApplyBtn}
            data={data}
            filterItem={filterItem}
            index={index}
            filterArray={filterArray}
            commonFilters={commonFilters}
            Sheetid={Sheetid}
            dataSourceID={dataSourceID}
          />
        );
      case "MultiValueCustomList":
        return (
          <MultiplevalueCustomList
            columnName={key}
            allOptions={value}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilters={setSelectedFilterValues}
            dispatchUpdateItem={dispatchUpdateItem}
            showApplyBtn={showApplyBtn}
          />
        );
      case "MultiValueList":
        return (
          <MultipleValueList
            columnName={key}
            allOptions={value}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilters={setSelectedFilterValues}
            dispatchUpdateItem={dispatchUpdateItem}
            showApplyBtn={showApplyBtn}
            filterItem={filterItem}
          />
        );
      default:
        return (
          <MultiValueDropDown
            columnName={key}
            allOptions={value}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilters={setSelectedFilterValues}
            dispatchUpdateItem={dispatchUpdateItem}
            showApplyBtn={showApplyBtn}
            data={data}
            filterItem={filterItem}
            index={index}
            filterArray={filterArray}
            commonFilters={commonFilters}
            Sheetid={Sheetid}
            dataSourceID={dataSourceID}
          />
        );
    }
  };

  if (isSuccess) {
    console.log(data);
    return (
      <>
        {Object.entries(data).map(([key, value]) => {
          console.log(key, value);
          if (
            (item.dataType === "String" || item.dataType === "Date") &&
            item.selectedOperator === "IN"
          ) {
            // dataType is string or date and opeartor should be IN
            console.log(key);
            return (
              <section key={key} className="w-full">
                <FilterDropDown
                  columnName={key}
                  filterComponentType={filterComponentType}
                  setFilterType={setFilterType}
                  showApplyBtn={showApplyBtn}
                  setShowApplyBtn={setShowApplyBtn}
                  item={item}
                  filterArray={filterArray}
                  dashboardSheetID={dashboardSheetID}
                  isFilterVisibleInDashboard={isFilterVisibleInDashboard}
                  Sheetid={Sheetid}
                  index={index}
                  commonFilters={commonFilters}
                  currentSheetType={currentSheetType}
                  dashboardType={dashboardType}
                />
                {renderFilterComponent(
                  filterComponentType,
                  key,
                  value.map((item) =>
                    item === null ? "NULL" : item === "" ? "BLANK" : item
                  ),
                  data,
                  item
                )}
              </section>
            );
          }
        })}
      </>
    );
  } else if (item.dataType === "Number") {
    // dataTyep is number
    return (
      <Number
        updateNumberFilterItem={updateNumberFilterItem}
        filterItem={item}
        dashboardSheetID={dashboardSheetID}
        isFilterVisibleInDashboard={isFilterVisibleInDashboard}
        dashboardType={dashboardType}
      />
    );
  } else if (item.dataType === "Date" && isRelativeDate) {
    console.log(item);
    return (
      <Aside3RelativeDate
        relativeDateItem={item}
        Sheetid={Sheetid}
        dashboardSheetID={dashboardSheetID}
        isFilterVisibleInDashboard={isFilterVisibleInDashboard}
        currentSheetType={currentSheetType}
        dashboardType={dashboardType}
      />
    );
  } else if (item.dataType === "Date" && item.selectedOperator === "BETWEEN") {
    return (
      <Aside3DateRangeComp
        updateDateFilterItem={updateDateFilterItem}
        filterItem={item}
        dashboardSheetID={dashboardSheetID}
        isFilterVisibleInDashboard={isFilterVisibleInDashboard}
        currentSheetType={currentSheetType}
        dashboardType={dashboardType}
      />
    );
  }
}
